import React from 'react'
import Field from './FormField'
import GalleryImage from './GalleryImage'
import imageUrl from '../../utils/imageUrl'

import styles from './Gallery.module.css'

export default ({
  images = [],
  onSelectFactory,
  onRemoveFactory,
  onCaptionChangeFactory,
  disabled,
  imageType = 'inventory'
}) =>
  <section>
    {images.map((image, i) => {
      const { path, url } = image.attributes
      const imagePath = url || (path ? imageUrl(imageType, path) : '')
      return (
        <Field
          key={i}
          className={styles.galleryItem}
          name={`Gallery Image #${i + 1}`}
        >
          <GalleryImage
            imagePath={imagePath}
            imageCaption={image.attributes.caption}
            onSelect={onSelectFactory(i)}
            onCaptionChange={onCaptionChangeFactory(i)}
            onRemove={onRemoveFactory(i)}
            disabled={disabled}
          />
        </Field>
      )
    })}
  </section>
